module.exports = __webpack_public_path__ + "static/media/SOLUS_LR_MARKER_348.75deg.49e65ef0.png";